// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"1bc106f9","507":"68b8c81e","679":"ced8f7cc","722":"3daa1306","787":"0083a0f5"}[chunkId] + ".chunk.js";
};